import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

const Header = styled.header`
  background: #fff;
  border-bottom: 1px solid #f1f4f9;
  padding: 16px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

const Title = styled.h1`
  font-size: 20px;
  font-weight: 500;
  color: #3e3c3c;
  margin: 0;
`;

const BackButton = styled.button`
  background: transparent;
  border: none;
  color: #0653f4;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 8px;
  gap: 8px;
  
  &:hover {
    color: #0442c3;
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: #f8f9fa;
`;

const Content = styled.main`
  flex: 1;
`;

interface AuthLayoutProps {
  children: React.ReactNode;
  title: string;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ children, title }) => {
  const navigate = useNavigate();

  return (
    <Container>
      <Header>
        <Title>{title}</Title>
        <BackButton onClick={() => navigate('/')}>
          ← Back to Dashboard
        </BackButton>
      </Header>
      <Content>
        {children}
      </Content>
    </Container>
  );
};

export default AuthLayout;